document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-faq-toggle]');
  if (!button) return;
  const open = button.closest('.faq-item').classList.toggle('open');
  button.setAttribute('aria-expanded', String(open));
});

function updateVariant(section) {
  const option = section.querySelector('[data-variant-select]')?.selectedOptions[0];
  if (!option) return;
  section.querySelector('[data-variant-price]').textContent = option.dataset.price;
  const quantity = section.querySelector('[data-quantity]');
  const min = Number(option.dataset.min) || 1;
  const step = Number(option.dataset.step) || 1;
  const limits = [option.dataset.ruleMax, option.dataset.stockMax].filter(v => v !== undefined && v !== '').map(Number);
  const max = limits.length ? Math.min(...limits) : Infinity;
  quantity.min = String(min);
  quantity.step = String(step);
  if (Number.isFinite(max)) quantity.max = String(max);
  else quantity.removeAttribute('max');
  const desired = Math.max(min, Number(quantity.value) || min);
  const aligned = min + Math.floor((desired - min) / step) * step;
  quantity.value = String(max >= min ? Math.min(aligned, min + Math.floor((max - min) / step) * step) : min);
  const button = section.querySelector('[data-add]');
  button.disabled = option.dataset.available !== 'true' || max < min;
  button.textContent = button.disabled ? button.dataset.soldLabel : button.dataset.addLabel;
}
document.querySelectorAll('[data-purchase]').forEach(updateVariant);
document.addEventListener('change', event => {
  if (event.target.matches('[data-variant-select]')) updateVariant(event.target.closest('[data-purchase]'));
});
document.addEventListener('shopify:section:load', event => {
  event.target.querySelectorAll('[data-purchase]').forEach(updateVariant);
});
